<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('优惠券名称')" prop="couponName">
                <a-input v-model="queryParam.couponName" :maxLength="32" :placeholder="$t('请输入')+$t('优惠券名称')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('优惠券类型')" prop="couponType">
                <a-select v-model="queryParam.couponType" :placeholder="$t('请选择')" allow-clear>
                  <a-select-option v-for="(item, index) in customDict.CouponTypeEnum" :value="item.type" :key="index">
                    {{ $t(item.name) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker
                  style="width: 100%"
                  v-model="queryParam.createBeginTime"
                  :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker
                  style="width: 100%"
                  v-model="queryParam.createEndTime"
                  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('是否新人券')" prop="isNewUser">
                <a-select v-model="queryParam.isNewUser"  allow-clear>
                  <a-select-option v-for="(item, index) in customDict.TFEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['coupon:coupon:add']">
          <a-icon type="plus" />
          {{ $t('新增') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['coupon:coupon:remove']">
          <a-icon type="delete" />
          {{ $t('删除') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :category-list = "goodsCategoryList"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <span slot="amount" slot-scope="text, record">
          <span v-if="record.couponType === 1">{{ record.amount }}</span>
          <span v-else-if="record.couponType === 2">{{ 100 - record.discountRate *100 }}% OFF</span>
          <span v-else-if="record.couponType === 3">{{ record.amount }}</span>
        </span>
        <span slot="couponType" slot-scope="text, record">
          <a-tag v-if="record.couponType === 1" color="blue">Spend&Save Coupon</a-tag>
          <a-tag v-else-if="record.couponType === 2" color="green">Discount Coupon</a-tag>
          <a-tag v-else-if="record.couponType === 3" color="orange">{{ $t('运费券') }}</a-tag>
        </span>
        <span slot="status" slot-scope="text, record">
           <custom-dict-tag :options="customDict.GoodsOnOffEnum"  :color="true" :color-array="['red','green']" :value="record.status"/>
        </span>
        <span slot="isNewUser" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum" :color="true" :color-array="['green','red']" :value="record.isNewUser"/>
        </span>
        <span slot="isPointExchange" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum"  :color="true" :color-array="['green','red']"  :value="record.isPointExchange"/>
        </span>
        <span slot="categoryId" slot-scope="text, record">
          {{ record.couponType === 3 ? $t('运费') : (record.categoryId === 0 ? 'All' : (goodsCategoryList.find(item => item.id === record.categoryId)?.categoryName || '-')) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['coupon:coupon:edit']">
            <a-icon type="edit" />{{ $t('修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['coupon:coupon:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['coupon:coupon:remove']">
            <a-icon type="delete" />{{ $t('删除') }}
          </a>
          <br />
          <a-divider type="vertical" v-hasPermi="['coupon:coupon:edit']" />
          <a @click="handleSendUserCoupon(record)" v-hasPermi="['coupon:coupon:edit']">
            <a-icon type="unordered-list" />{{ $t('手动发放') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['coupon:coupon:edit']" />
          <a @click="handleOpenReceiveRecord(record)" v-hasPermi="['coupon:coupon:edit']">
            <a-icon type="unordered-list" />{{ $t('领取记录') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <user-select-table ref="userSelectTableRef" @ok="handleUserSelected" />
    <coupon-user-drawer ref="userCouponDrawerRef" />
  </page-header-wrapper>
</template>

<script>
import { pageCoupon, listCoupon, delCoupon, sendToUsersCoupon } from '@/api/coupon/coupon'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { listCategory } from '@/api/goods/category'
import checkboxUserSelectForm from '@/views/user/user/modules/CheckboxSelectForm.vue'
import UserSelectTable from '@/components/user/UserSelectTable/index.vue'
import CouponUserDrawer from '@/views/coupon/couponUser/modules/CouponUserDrawer.vue'

export default {
  name: 'Coupon',
  components: {
    CouponUserDrawer,
    UserSelectTable,
    checkboxUserSelectForm,
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        couponName: undefined,
        couponType: undefined,
        amount: undefined,
        isNewUser: undefined,
        isPointExchange: undefined,
        categoryId: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('优惠券名称'),
          dataIndex: 'couponName',
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: this.$t('面额'),
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('发放数量'),
          dataIndex: 'totalIssue',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('优惠券类型'),
          dataIndex: 'couponType',
          scopedSlots: { customRender: 'couponType' },
          align: 'center'
        },
        {
          title: this.$t('满多少元可用'),
          dataIndex: 'thresholdAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('使用范围'),
          dataIndex: 'categoryId',
          scopedSlots: { customRender: 'categoryId' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('有效期开始时间'),
          dataIndex: 'validStartTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('有效期结束时间'),
          dataIndex: 'validEndTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('是否新人券'),
          dataIndex: 'isNewUser',
          scopedSlots: { customRender: 'isNewUser' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('是否可积分兑换'),
          dataIndex: 'isPointExchange',
          scopedSlots: { customRender: 'isPointExchange' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('积分'),
          dataIndex: 'needPoints',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '220px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ],
      goodsCategoryList: [],
      handleCouponId: undefined
    }
  },
  filters: {},
  created() {
    this.getList()
    this.getGoodsCategoryList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询优惠券列表 */
    getList() {
      this.loading = true
      pageCoupon(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getGoodsCategoryList() {
      listCategory().then(response => {
        this.goodsCategoryList = response.data || []
        this.goodsCategoryList.unshift({"id":"0","categoryName":"ALL"})
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        couponName: undefined,
        couponType: undefined,
        amount: undefined,
        isNewUser: undefined,
        isPointExchange: undefined,
        categoryId: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delCoupon(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('coupon/coupon/export',
            that.queryParam
            , `${that.$t('优惠券')}_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    handleSendUserCoupon(row) {
      this.handleCouponId = row.id
      this.$refs.userSelectTableRef.open()
    },
    handleUserSelected(userIdList) {
      console.log('handleUserSelected , userIdList : ', this.handleCouponId, userIdList)
      if (!this.handleCouponId || !userIdList || userIdList.length <= 0) {
        return
      }
      sendToUsersCoupon({
        id: this.handleCouponId,
        userIdList: userIdList
      }).then(() => {
        this.onSelectChange([], [])
        this.getList()
        const message = this.$t('发放成功')
        this.$message.success(
          message,
          3
        )
      }).finally(() => {
        this.handleCouponId = undefined
      })
    },
    handleOpenReceiveRecord(row) {
      this.$refs.userCouponDrawerRef.open(row.id)
    }
  }
}
</script>
